import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { NumericInputField, DatePickerField, BaasicButton, BaasicFieldDropdown, BaasicDropdown, BaasicModal } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';
import { Generate} from 'application/schedule/components';

function FacilityScheduleTemplate({ editView }) {
    const {
        item,
        contentLoading,
        form,
        addSchedule,
        itemsConstructed,
        areaOfCareStore,
        areaOfCares,
        selectedAreaOfCares,
        removeSchedule,
        selectedAreaOfCare,
        generateModal,
        openGenerateModal,
        hasPermission
    } = editView;

    const schedules = item && itemsConstructed ? item.schedules.map(i => 
        <div className="row" key={i.id}>
            <div className="u-mar--bottom--med col col-sml-12 col-lrg-2 u-mar--bottom--sml">
                <label className="form__group__label">&nbsp;</label>
                <React.Fragment>{i.areaOfCareName}</React.Fragment>
            </div>
            <div className="u-mar--bottom--med col col-sml-12 col-lrg-2 u-mar--bottom--sml">
                <DatePickerField field={form.$('schedules').$('item-' + i.areaOfCareId).$('startDate')} />
            </div>
            <div className="u-mar--bottom--med col col-sml-12 col-lrg-3 u-mar--bottom--sml">
                <BaasicFieldDropdown store={i.daysOfWeekStore} field={form.$('schedules').$('item-' + i.areaOfCareId).$('dayOfTheWeek')} />
            </div>
            <div className="u-mar--bottom--med col col-sml-12 col-lrg-2 u-mar--bottom--sml">
                <NumericInputField field={form.$('schedules').$('item-' + i.areaOfCareId).$('weeks')} />
            </div>
            <div className="u-mar--bottom--med col col-sml-12 col-lrg-2 u-mar--bottom--sml">
                <NumericInputField field={form.$('schedules').$('item-' + i.areaOfCareId).$('orderingScheduleNoOfDays')} />
            </div>
            <BaasicButton
                className="btn btn--icon btn--icon--sml-med is-delete u-align--self--center"
                icon='u-icon u-icon--delete u-icon--sml'
                label='Delete'
                onlyIcon={true}
                onClick={() => removeSchedule(i.areaOfCareId)}
                disabled={!hasPermission}
            />
            <div className="col col-sml-12">
                <div className="u-separator--primary"></div>
            </div>    
        </div>
    ) : null;

    return (
        <React.Fragment>
            <ApplicationEditLayout store={editView}>
                <Content loading={contentLoading} >
                    {item  && itemsConstructed ?
                    <div className="row">
                        <div className="col col-sml-12 col-lrg-8">
                            <div className="card card--form card--primary card--med">
                                <div className="card__header u-mar--bottom--sml form__title form__title--preview">
                                    <h4>Facility Schedule</h4>                           
                                    <BaasicButton
                                        className={'btn btn--base btn--primary u-mar--left--auto'}
                                        label={'Generate Dates'} 
                                        onClick={() => openGenerateModal()}
                                        authorized={hasPermission}
                                    />  
                                </div>
                                <div className="row">
                                    <div className="u-mar--bottom--med col col-lrg-4 u-mar--bottom--sml">
                                        <DatePickerField field={form.$('facilitySchedule').$('startDate')} />
                                    </div>
                                    <div className="u-mar--bottom--med col col-lrg-4 u-mar--bottom--sml">
                                        <BaasicFieldDropdown field={form.$('facilitySchedule').$('dayOfTheWeek')} store={item.facilitySchedule.daysOfWeekStore} />
                                    </div>
                                    <div className="u-mar--bottom--med col col-lrg-2 u-mar--bottom--sml">
                                        <NumericInputField field={form.$('facilitySchedule').$('weeks')} />
                                    </div>
                                    <div className="u-mar--bottom--med col col-lrg-2 u-mar--bottom--sml">
                                        <NumericInputField field={form.$('facilitySchedule').$('orderingScheduleNoOfDays')} />
                                    </div>
                                    <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                        <h4 className="form__title">Areas of Care</h4>
                                        {schedules}
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {selectedAreaOfCares.length < areaOfCares.length &&
                                            <div className="inputgroup">
                                                <div className="inputgroup--main">
                                                    <BaasicDropdown store={areaOfCareStore} placeholder="Select Area of Care" />
                                                </div>
                                                <div className="inputgroup--aside">
                                                    <BaasicButton disabled={selectedAreaOfCare == null} className="btn btn--base btn--primary" label={'Add Schedule'} onClick={addSchedule}></BaasicButton>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}
                </Content>
            </ApplicationEditLayout>
            <BaasicModal modalParams={generateModal}>
                <Generate />
            </BaasicModal>
        </React.Fragment>
    )
}

FacilityScheduleTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityScheduleTemplate);
